export default "/images/carlsplatz.jpg?bd6acb477a69c981830ff483935ba2dc";